// extracted by mini-css-extract-plugin
export default {"container":"resolution-warning-message_container__19XRT","icon":"resolution-warning-message_icon__-kT2I"};